module.exports = __webpack_public_path__ + "static/media/icon_btc.ef68d3cb.svg";